import * as colors from '@mui/material/colors';

const white = '#FFFFFF';
const black = '#000000';

export default {
   black,
   white,
   primary: {
      contrastText: white,
      dark: '#8866CC',
      main: '#9C70C2',
      light: '#E2DCEF',
      disabled: colors.grey[500]
   },
   secondary: {
      contrastText: white,
      dark: '#6C63FF',
      main: '#8095FF',
      light: '#CCD4FF'
   },
   success: {
      contrastText: white,
      dark: '#14B858',
      main: '#00CC44',
      light: '#D9F2E3'
   },
   info: {
      contrastText: white,
      dark: '#009DDB',
      main: '#00B8D9',
      light: '#B2F2FF'
   },
   warning: {
      contrastText: white,
      dark: '#F2930D',
      main: '#FFAB00',
      light: '#FFF6CC'
   },
   error: {
      contrastText: white,
      dark: '#FF1744',
      main: '#F76666',
      light: '#FFBFB2'
   },
   text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
      link: colors.blue[600]
   },
   background: {
      default: '#F8FAFD',
      paper: white
   },
   palette01: {
      contrastText: white,
      dark: colors.indigo[800],
      main: colors.indigo[600],
      light: colors.indigo[50]
   },
   icon: colors.blueGrey[600],
   divider: '#CECECE'
};
